import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'profile.yearOfBirth.label': {
    id: 'profile.yearOfBirth.label',
    defaultMessage: 'Year of birth',
    description: 'The label for year of birth in a user profile.',
  },
  'profile.yearOfBirth.empty': {
    id: 'profile.yearOfBirth.empty',
    defaultMessage: 'Add year of birth',
    description: "The affordance to add year of birth to a user's profile.",
  },
  'profile.yearOfBirth.placeholder': {
    id: 'profile.yearOfBirth.placeholder',
    defaultMessage: 'Fill in your year of birth.',
    description: "The placeholder for adding year of birth to a user's profile.",
  },
  'profile.yearOfBirth.option.default': {
    id: 'profile.yearOfBirth.option.default',
    defaultMessage: 'Select year of your birth',
  },
});

export default messages;
